module.exports = __webpack_public_path__ + "img/icon-com.2681ebb1.png";